/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ITextBlockViewProps } from '@msdyn365-commerce-modules/text-block/src/modules/text-block/./text-block';

const TextBlockView: React.FC<ITextBlockViewProps> = props => (
    <div className={props.className} {...props.renderModuleAttributes(props)}>
        {props.paragraph}
    </div>
);

export default TextBlockView;
